import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ITitulo } from './interfaces/titulo.interface';
import { TituloService } from './services/titulo.service';
import { MatDialog } from '@angular/material/dialog';
import { AbcEmpresasCustomizablesComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-customizables/abc-empresas-customizables.component';

@Component({
  selector: 'app-titulo-form',
  templateUrl: './titulo-form.component.html',
  providers: [MessageService]
})
export class TituloFormComponent implements OnInit, OnChanges {
  @Input() model: ITitulo | null = null;
  @Output() onSave = new EventEmitter<{ success: boolean; message: string }>();
  form!: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private tituloService: TituloService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model']) {
      if (changes['model'].currentValue) {
        this.loadTitulo();
      } else {
        this.initForm();
      }
    }
  }

  initForm(): void {
    this.form = this.fb.group({
      titulo: [{ value: '', disabled: !!this.model }, [
        Validators.required,
        Validators.maxLength(4)
      ]],
      descripcion: ['', [Validators.required]]
    });
  }

  loadTitulo(): void {
    if (this.model?.titulo) {
      this.loading = true;
      this.tituloService.getTituloDetail(this.model.titulo).subscribe({
        next: (response) => {
          if (response.success && response.data.length > 0) {
            const titulo = response.data[0];
            this.form.patchValue({
              titulo: titulo.titulo,
              descripcion: titulo.descripcion
            });
            this.form.get('titulo')?.disable();
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'No se pudo cargar el título'
            });
          }
          this.loading = false;
        },
        error: (error) => {
          console.error('Error al cargar título:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al cargar el título'
          });
          this.loading = false;
        }
      });
    }
  }

  create(): void {
    if (this.form.invalid) {
      if (this.form.get('titulo')?.errors?.['maxlength']) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'El título no puede tener más de 4 letras'
        });
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Por favor complete todos los campos requeridos'
        });
      }
      return;
    }

    this.loading = true;
    const formData = this.form.getRawValue();
    
    this.tituloService.saveTitulo(formData).subscribe({
      next: (response) => {
        if (response.success) {
          this.onSave.emit({ success: true, message: 'Título creado exitosamente' });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.data.error || 'No se pudo crear el título'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al crear título:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al crear el título'
        });
        this.loading = false;
      }
    });
  }

  update(): void {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      return;
    }

    this.loading = true;
    const formData = this.form.getRawValue();
    
    this.tituloService.updateTitulo(formData).subscribe({
      next: (response) => {
        if (response.success) {
          this.onSave.emit({ success: true, message: 'Título actualizado exitosamente' });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.data?.error || 'No se pudo actualizar el título'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al actualizar título:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al actualizar el título'
        });
        this.loading = false;
      }
    });
  }

  openCustomizables(): void {
    this.dialog.open(AbcEmpresasCustomizablesComponent, {
      width: '1000px',
      height: '1000px',
      disableClose: true,
      panelClass: ['custom-dialog-zindex'],
      hasBackdrop: true,
      autoFocus: false,
      data: {
        sTabla: 'titulos',
        sClave: `${this.form.get('titulo')?.value}`,
        sNombre: this.form.get('descripcion')?.value,
        sTipo: 'Opcion'
      }
    });
  }

  onDialogClosed(): void {
    this.form.reset();
    this.model = null;
  }
}